var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "touch-swipe",
          rawName: "v-touch-swipe.noMouse.left.right",
          value: _vm.userHasSwiped,
          expression: "userHasSwiped",
          modifiers: { noMouse: true, left: true, right: true }
        }
      ],
      staticClass: "container",
      style: _vm.container_style
    },
    [
      _c(
        "v-zoomer",
        {
          staticClass: "player",
          style: _vm.player_style,
          attrs: { pivot: "cursor", limitTranslation: false }
        },
        [
          _c("div", { staticClass: "player", style: _vm.player_style }, [
            _c("img", {
              staticClass: "slide",
              staticStyle: { "object-fit": "contain" },
              style: _vm.slide_style,
              attrs: { src: _vm.getSlide }
            })
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "controller bg-secondary", style: _vm.controller_style },
        [
          _c("q-btn", {
            attrs: {
              color: "white",
              size: "lg",
              flat: "",
              icon: "fas fa-chevron-left",
              disable: _vm.disableButtonPrevious
            },
            on: {
              click: function($event) {
                return _vm.goLeft()
              }
            }
          }),
          _c("q-btn", {
            attrs: {
              color: "white",
              size: "lg",
              flat: "",
              icon: "fas fa-chevron-right",
              disable: _vm.disableButtonNext
            },
            on: {
              click: function($event) {
                return _vm.goRight()
              }
            }
          }),
          _c("q-btn", {
            staticClass: "fullscreen",
            attrs: {
              color: "white",
              size: "lg",
              flat: "",
              icon: "fas fa-compress"
            },
            on: {
              click: function($event) {
                return _vm.fullScreen()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }